(() => {
  const buttons = [...document.querySelectorAll('[data-add-lance-set]')];
  if (!window.LanceSelection || !buttons.length) return;
  let busy = false;
  buttons.forEach(button => {
    button.hidden = false;
    button.addEventListener('click', async () => {
      if (busy) return;
      busy = true;
      buttons.forEach(item => { item.disabled = true; });
      const card = button.closest('[data-lance-set]');
      const status = card.querySelector('[data-set-status]');
      button.setAttribute('aria-busy', 'true');
      status.textContent = 'Adding your tools…';
      try {
        const items = button.dataset.selection.split(',').map(line => {
          const [, id, quantity] = line.split('~');
          return { id: Number(id), quantity: Number(quantity) };
        });
        await window.LanceSelection.add(items);
        window.LanceSelection.signal('lance_set_added', { job: card.dataset.lanceSet, tool_quantity: items.reduce((n, item) => n + item.quantity, 0) });
        status.textContent = 'Set added. Opening your cart…';
        location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch {
        // A connection failure can occur after Shopify accepted the add. Never
        // blindly retry and risk doubling a customer's selection.
        status.textContent = 'We could not confirm the complete set. Some tools may have been added. ';
        const link = document.createElement('a');
        link.href = (window.Shopify?.routes?.root || '/') + 'cart';
        link.textContent = 'Review your cart before trying again →';
        status.append(link);
        button.textContent = 'Check your cart';
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  });
})();
